import { useEffect, useState } from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

import icClose from "@/assets/images/user/icClose.svg";
import icZoomIn from "@/assets/images/user/icZoomIn.svg";
import icZoomOut from "@/assets/images/user/icZoomOut.svg";
import { Dialog, DialogClose, DialogContent, DialogTrigger } from "@/components/ui/dialog";

export default function ImgZoomPop({ img }: { img: string }) {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [maxScale, setMaxScale] = useState<number>(4);

    useEffect(() => {
        const updateMaxScale = () => {
            setMaxScale(window.innerWidth >= 768 ? 4 : 8);
        };

        const handleResize = () => {
            if (isOpen) {
                setIsOpen(false);
            }
            updateMaxScale();
        };

        updateMaxScale();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [isOpen]);

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild className="cursor-pointer">
                <img src={img} alt="map" />
            </DialogTrigger>
            <DialogContent className="h-full max-w-none p-0 overflow-hidden !rounded-none shadow-none border-none bg-transparent [&>button]:hidden">
                <TransformWrapper
                    initialScale={1}
                    minScale={1}
                    maxScale={maxScale}
                    initialPositionX={200}
                    initialPositionY={100}
                >
                    {({ zoomIn, zoomOut }) => (
                        <>
                            <TransformComponent wrapperClass="!h-full">
                                <img src={img} alt="map" />
                            </TransformComponent>
                            <div className="fixed bottom-[20px] left-1/2 -translate-x-1/2 p-[8px_20px] flex items-center justify-center gap-[24px] bg-[rgba(0,0,0,0.6)] rounded-[40px] z-50">
                                <button
                                    type="button"
                                    onClick={() => zoomIn()}
                                    className="hover:opacity-80 transition-opacity"
                                >
                                    <img src={icZoomIn} alt="확대" className="size-[24px] md:size-[40px]" />
                                </button>
                                <button
                                    type="button"
                                    onClick={() => zoomOut()}
                                    className="hover:opacity-80 transition-opacity"
                                >
                                    <img src={icZoomOut} alt="축소" className="size-[24px] md:size-[40px]" />
                                </button>
                                <DialogClose asChild>
                                    <button type="button" className="hover:opacity-80 transition-opacity">
                                        <img src={icClose} alt="닫기" className="size-[24px] md:size-[40px]" />
                                    </button>
                                </DialogClose>
                            </div>
                        </>
                    )}
                </TransformWrapper>
            </DialogContent>
        </Dialog>
    );
}
